import { FlagBanner } from '@phosphor-icons/react';

export default FlagBanner;
